import _ from 'lodash';
import { deserialise } from '~/utils/jsonApi/deserialise';
import ApiClient from '~/services/client';
import { routerRedux } from 'dva/router';
import { getPageInfo } from '../utils/table';
import { redirectToIndex } from '../utils/router';
import initialState from './initialStates/resource';

const resource = 'contents';

export default {
  namespace: resource,
  state: initialState,
  effects: {
    *fetch({ payload }, { call, put }) {
      const { pageNumber, pageSize, sortField, sortOrder, filters, searchQuery, extraQueries } = payload;
      const response = yield call(ApiClient.contents.search, {
        pageNumber,
        pageSize,
        sortField,
        sortOrder,
        filters,
        searchQuery,
        extraQueries,
      });
      yield put({
        type: 'readResource',
        payload: {
          ...response,
          extraQueries,
        },
      });
    },
    *create({ payload }, { call, put, select }) {
      const { params, tagParams = {} } = payload;
      const response = yield call(ApiClient.contents.create, params);
      if (response) {
        if (!_.isEmpty(tagParams.tag_name)) {
          yield put.resolve({
            type: 'resource_tags/create',
            payload: {
              id: response.data.id,
              resourceType: resource,
              params: {
                ...tagParams,
              },
            },
          });
        }
        yield put({
          type: 'createResource',
          payload: response,
        });
        yield call(redirectToIndex, { put, select }, `library/${resource}/${_.lowerCase(params.contentType)}`);
      }
    },
    *read({ payload }, { call, put }) {
      const { id } = payload;
      const response = yield call(ApiClient.contents.read, id);
      yield put({
        type: 'currentResource',
        payload: response,
      });
    },
    *update({ payload }, { call, put, select }) {
      const { id, params } = payload;
      const response = yield call(ApiClient.contents.update, id, params);
      if (response) {
        yield put({
          type: 'updateResource',
          payload: response.data,
        });
        yield call(redirectToIndex, { put, select }, `library/${resource}/${_.lowerCase(params.contentType)}`);
      }
    },
    *delete({ payload }, { call, put }) {
      const { id, contentType } = payload;
      yield call(ApiClient.contents.delete, id, contentType);
      yield put({
        type: 'deleteResource',
        payload: { id },
      });
      yield put({
        type: 'fetch',
        payload: {
          extraQueries: {
            contentType: 'Education',
          },
        },
      });
      yield put(routerRedux.push('/library/contents/education'));
    },
  },
  reducers: {
    readResource(state, action) {
      const { links, extraQueries } = action.payload;
      const { pageNumber, pageSize, total, sortField, sortOrder, searchQuery } = getPageInfo(links);
      const deserialisedPayload = deserialise(action.payload);
      return {
        ...state,
        list: deserialisedPayload.data,
        pageNumber,
        pageSize,
        total,
        sortField,
        sortOrder,
        searchQuery,
        extraQueries,
      };
    },
    createResource(state) {
      return {
        ...state,
      };
    },
    updateResource(state, action) {
      const { attributes } = action.payload;
      return {
        ...state,
        resource: attributes,
      };
    },
    currentResource(state, action) {
      const deserialisedData = deserialise(action.payload);
      return {
        ...state,
        resource: deserialisedData.data,
      };
    },
    deleteResource(state) {
      return {
        ...state,
      };
    },
  },
};
